import React, { memo } from "react";

import colors from "app/colors";
import { useMixpanel } from "modules/providers/mixpanel-provider";
import { MIXPANEL_EVENT_TYPE } from "modules/providers/mixpanel-provider/mixpanel-provider";
import { PencilOutlineIcon } from "modules/icons";
import { useOverlay } from "modules/providers/overlay-provider";
import { DRAWER_TYPE } from "modules/providers/overlay-provider/overlay-provider";
import { Button } from "@chakra-ui/react";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import { THREAD_DRAFT_ID } from "modules/utils/Constants";
import { MessageThreadType } from "gql/graphql";

export const LeftNavCreateThreadButton = () => {
  const { openDrawer } = useOverlay();
  const { track } = useMixpanel();
  const { createDraft } = useMessageThreadDraft({ draftId: THREAD_DRAFT_ID });

  const onNewThreadClicked = React.useCallback(async () => {
    await createDraft({
      type: MessageThreadType.Thread,
      draftType: "new-thread",
    });
    openDrawer({ type: DRAWER_TYPE.COMPOSE_THREAD });
    track(MIXPANEL_EVENT_TYPE.LINK, {
      "Link Location": "Left Hand Nav",
      "Link Action": "New Thread",
    });
  }, [createDraft, openDrawer, track]);

  return (
    <Button
      aria-label="new thread"
      variant="hover"
      backgroundColor={colors.orangePrimary}
      color={colors.white}
      size="xs"
      rounded="full"
      iconSpacing={0}
      fontSize={10}
      fontWeight={700}
      onClick={onNewThreadClicked}
      leftIcon={<PencilOutlineIcon boxSize={3} fill={colors.white} />}
      px={2}
      w="78px"
    >
      New Thread
    </Button>
  );
};

export default memo(LeftNavCreateThreadButton);
